import { useVendorContext } from 'Data/context/Vendors';
import PropTypes from 'prop-types';
import BOSFilterSelect from './index';

const VendorSelect = ({
  onSelectVendor,
  defaultSelectedId,
  isRequired = false,
  isForRequest,
  ...props
}) => {
  const { getFilteredList } = useVendorContext();
  let filteredList = getFilteredList({ isForRequest });

  return (
    <BOSFilterSelect
      listData={filteredList}
      onItemSelect={onSelectVendor}
      placeholder='Select a Vendor...'
      defaultSelectedId={defaultSelectedId}
      fill
      isRequired={isRequired}
      isForRequest={isForRequest}
      {...props}
    />
  );
};

VendorSelect.propTypes = {
  onSelectVendor: PropTypes.func,
  defaultSelectedId: PropTypes.number,
  isRequired: PropTypes.bool,
  isForRequest: PropTypes.bool,
  onBlur: PropTypes.func,
};

export default VendorSelect;
